import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(home)/auth/forgotten-password/page.tsx");
